import React from "react";
import EpisodeCard from "../../components/public/EpisodeCard";
import BlogCard from "../../components/public/BlogCard";
import "./HomePage.css";

export default function HomePage({
  episodes,
  liveData,
  aboutData,
  posts,
  setPage,
  setModal,
  setBlogPost,
}) {
  return (
    <>
      {/* Live banner */}
      {liveData.isLive && (
        <div className="live-banner" onClick={() => setPage("live")}>
          <h3>
            <span className="live-dot-lg" />
            WE ARE LIVE RIGHT NOW
          </h3>
          <p>Click to watch the live stream ›</p>
        </div>
      )}

      {/* Hero */}
      <div className="hero">
        <div className="hero-stars" aria-hidden>
          ★★★★★
          <br />
          ★★★★★
          <br />
          ★★★★★
        </div>
        <div className="hero-content fade-up">
          <div className="hero-eyebrow">Let's Talk LLC Presents</div>
          <h1 className="hero-title">
            Talk
            <br />
            <span>News</span>
          </h1>
          <p className="hero-sub">
            The Kedrick Scribner Network — tackling trending issues on law
            enforcement, justice, and the stories shaping America and the world.
            No filter. No fluff. Just truth.
          </p>
          <div className="hero-badges">
            <span className="badge">⭐ Former Marine</span>
            <span className="badge">🚔 Former Law Enforcement</span>
            <span className="badge">🎙 Talk Show Host</span>
          </div>
          <div className="hero-btns">
            <button className="btn-primary" onClick={() => setPage("episodes")}>
              Watch Episodes
            </button>
            <button className="btn-secondary" onClick={() => setPage("live")}>
              Watch Live →
            </button>
          </div>
        </div>
      </div>

      {/* Latest Episodes */}
      <section className="home-section home-section--dark">
        <div className="section-inner">
          <div className="section-label">Latest</div>
          <h2 className="section-title">Recent Episodes</h2>
          {episodes.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">🎙</div>
              <p>Episodes will appear here once added from the admin panel.</p>
            </div>
          ) : (
            <div className="card-grid">
              {episodes.slice(0, 3).map((ep) => (
                <EpisodeCard
                  key={ep.id}
                  episode={ep}
                  onClick={() => setModal(ep)}
                />
              ))}
            </div>
          )}
          {episodes.length > 3 && (
            <div className="section-cta">
              <button
                className="btn-primary"
                onClick={() => setPage("episodes")}
              >
                View All Episodes
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Latest Blog Posts */}
      {posts.length > 0 && (
        <section className="home-section">
          <div className="section-inner">
            <div className="section-label">Blog</div>
            <h2 className="section-title">Latest Articles</h2>
            <div className="card-grid">
              {posts.slice(0, 3).map((p) => (
                <BlogCard
                  key={p.id}
                  post={p}
                  onClick={() => {
                    setBlogPost(p);
                    setPage("blog");
                  }}
                />
              ))}
            </div>
            {posts.length > 3 && (
              <div className="section-cta">
                <button
                  className="btn-secondary"
                  onClick={() => setPage("blog")}
                >
                  Read All Articles
                </button>
              </div>
            )}
          </div>
        </section>
      )}

      {/* Host strip */}
      <section className="host-strip">
        <div className="section-inner host-strip-inner">
          {aboutData.photoUrl ? (
            <img src={aboutData.photoUrl} className="host-avatar" alt="Kedrick Scribner" />
          ) : (
            <div className="host-avatar host-avatar--placeholder">🎙</div>
          )}
          <div className="host-strip-info">
            <div className="host-label">Your Host</div>
            <div className="host-name">{aboutData.name || "Kedrick Scribner"}</div>
            <div className="host-tagline">
              {aboutData.tagline || "Former Marine · Former Law Enforcement · Talk Show Host"}
            </div>
            {/* Social icons */}
            <div className="host-socials">
              {aboutData.youtube   && <a href={aboutData.youtube}   target="_blank" rel="noopener noreferrer" className="host-social-link" title="YouTube">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1C24 15.9 24 12 24 12s0-3.9-.5-5.8zM9.75 15.5V8.5l6.5 3.5-6.5 3.5z"/></svg>
              </a>}
              {aboutData.twitter   && <a href={aboutData.twitter}   target="_blank" rel="noopener noreferrer" className="host-social-link" title="X / Twitter">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>}
              {aboutData.instagram && <a href={aboutData.instagram} target="_blank" rel="noopener noreferrer" className="host-social-link" title="Instagram">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>}
              {aboutData.facebook  && <a href={aboutData.facebook}  target="_blank" rel="noopener noreferrer" className="host-social-link" title="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>}
            </div>
          </div>
          <button className="btn-secondary host-bio-btn" onClick={() => setPage("about")}>
            Read Full Bio →
          </button>
        </div>
      </section>

    </>
  );
}
